import styled, { css } from 'styled-components';
import { Typography } from '../../../../../global/theme';
import { tablet } from '../../../../../global/mediaQueryMixin';

const SectionDiv = styled.div`
  min-width: 540px;
  width: 100%;
  position: relative;
  ${tablet(css`
    min-width: 430px;
  `)}
  @media (max-width: 767px) {
    display: none;
  }
`;

const GradientDiv = styled.div`
  position: absolute;
  bottom: -7px;
  left: 0;
  height: 250px;
  width: 100%;
  background: var(--background-overlay-gradient);
  z-index: 999;
`;

const CardContainer = styled.div`
  min-width: 748px;
  margin: 0 8px;
  border-radius: 16px;
  border-width: 0.5px;
  background: var(--background-tertiary);
  border: 0.5px solid var(--border-primary);
  box-shadow: -2px 0px 8px 0px #2a2a2a14;
`;

const HeaderSection = styled.div`
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  border-bottom: 0.5px solid var(--border-primary);
`;

const CardIcon = styled.div`
  padding: 8px;
  border: 0.5px solid var(--border-primary);
  border-radius: 8px;
  background-color: var(--background-primary);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TabSection = styled.div`
  max-width: 260px;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  opacity: 0.6;
`;

const TabItem = styled.div`
  height: 18px;
  border-radius: 4px;
  background-color: var(--background-muted);
  width: 100%;
`;

const BottomSection = styled.div`
  padding: 20px;
  width: calc(100% - 40px);
  opacity: 0.6;
  display: flex;
  flex-direction: column;
  gap: 33px;
`;

const ListSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ListTitle = styled.div`
  background: var(--background-muted);
  border-radius: 999px;
  height: 12px;
  width: 100px;
`;

const BorderDiv = styled.div`
  border-bottom: 0.5px solid var(--border-primary);
  margin-bottom: 3px;
`;

const ListBottomSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const ProjectDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Status = styled.div`
  width: 14px;
  height: 14px;
  border-radius: 999px;
  background-color: var(--background-muted);
`;
const ProjectName = styled.div`
  background: var(--background-muted);
  border-radius: 999px;
  height: 12px;
  width: 480px;
  &.w-390 {
    width: 390px;
  }
  &.w-280 {
    width: 280px;
  }
  &.w-170 {
    width: 170px;
  }
`;

const ProjectDetails = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ProjectTitle = styled.p`
  max-width: 300px;
  margin: 0;
  ${Typography.body_lg_semibold}
  color: var(--text-primary);
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-all;
  white-space: pre-wrap;
  ${tablet(css`
    max-width: 170px;
  `)}
`;

export {
  SectionDiv,
  GradientDiv,
  CardContainer,
  CardIcon,
  TabSection,
  HeaderSection,
  TabItem,
  BottomSection,
  ListSection,
  ListTitle,
  BorderDiv,
  ListBottomSection,
  ProjectDiv,
  Status,
  ProjectName,
  ProjectDetails,
  ProjectTitle
};
